import ContactsContainer from '@/containers/audience/ContactsContainer';

export default [
  {
    path: '/audience/contacts/:authProvider?',
    name: 'audience',
    meta: { requiresAuth: true, action: 'view', subject: 'contact' },
    component: ContactsContainer,
  },
];



// WEBPACK FOOTER //
// ./src/router/audience.js